import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { reportDTO } from "./api-interfaces/api-reports-interface";
import { HelperService } from "../helperService";


@Injectable({
    providedIn: 'root'
})

export class APIReportService {
    ApiURL: string = "";
    constructor(private http: HttpClient,public helperService: HelperService) {
        this.ApiURL = environment.ReportUrl + 'Reports/';
    }



  public getReportsFilterDropDown(roleId:number,countryId?: number, secondId?: number, thirdId?: number, fourthId?: number, fifthId?: number, sixId?:number): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const url =
      `${this.ApiURL}GetFiltersByRole/${roleId}` +
      (countryId ? `/${countryId}` : '')+
      (secondId ? `/${secondId}` : '')+
      (thirdId ? `/${thirdId}` : '') +
      (fourthId ? `/${fourthId}` : '') +
      (fifthId ? `/${fifthId}` : '') +
      (sixId ? `/${sixId}` : '');
    const requestOptions = {
        headers: headers,
      };
    return this.http.get(url, requestOptions);
  }

  public gettoken(): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const url =`${this.ApiURL}TestReport`;
    const requestOptions = {
        headers: headers,
      };
    return this.http.get(url, requestOptions);
  }

  public post(roleId:number,ReportId:number,isExport:number, isIncadea:number, parameters:reportDTO):Observable<any> {
      //  return this.http.post(`${this.ApiURL}GetReport?roleid=${roleId}&reportid=${ReportId}&isExport=${isExport}`,isExport===0? parameters:parameters,  {responseType:'blob'})
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const url = `${this.ApiURL}GetReport?roleid=${roleId}&reportid=${ReportId}&isExport=${isExport}&isIncadea=${isIncadea}`
    if (isExport===0) {
      const requestOptions = {
        headers: headers,
      };
      return this.http.post<any>(url ,parameters, requestOptions)
    }
    else {
      const requestOptions = {
        headers: headers,
        responseType:'blob' as 'json'
      };
      return this.http.post<Blob>(url, parameters, requestOptions)
    }
  }

}
